module.exports = __webpack_public_path__ + "static/media/cloudImg.a784afa4.svg";